setValue<template>
  <div>
    <component
      v-for="(form, index) in forms"
      :key="index"
      :is="getComponentName(form.input_type)"
      :form="form"
      class="mt-4"
      @setValue="setContentsValue"
      :value="getValue(form)"
    >
    </component>
  </div>
</template>

<script>
import _ from "lodash";
import { VESSEL_BEHAVIOR_REPORT_INPUT_TYPES } from "@/config/const";

import FormFixed from "./forms/FormFixed";
import FormDatePicker from "./forms/FormDatePicker";
import FormTimePicker from "./forms/FormTimePicker";
import FormDateTimePicker from "./forms/FormDateTimePicker";
import FormSelect from "./forms/FormSelect";
import FormHierarchicalSelect from "./forms/FormHierarchicalSelect";
import FormCheckBox from "./forms/FormCheckBox";
import FormRadioButton from "./forms/FormRadioButton";
import FormNumber from "./forms/FormNumber";
import FormShortText from "./forms/FormShortText";
import FormLongText from "./forms/FormLongText";
import FormSingleFile from "./forms/FormSingleFile";
import FormMultipleFile from "./forms/FormMultipleFile";


import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("vesselNoonReportDetail");

export default {
  components: {
    FormFixed,
    FormDatePicker,
    FormTimePicker,
    FormDateTimePicker,
    FormSelect,
    FormHierarchicalSelect,
    FormCheckBox,
    FormRadioButton,
    FormNumber,
    FormShortText,
    FormLongText,
    FormSingleFile,
    FormMultipleFile
  },
  data () {
    return {
      contentsValue: {},
    }
  },
  computed: {
    ...mapState(["reportItems", "reportDetail", "version"]),
    forms () {
      if (!this.reportItems.items) return [];
      const reports = this.reportItems.items.map(item => {
        const _item = _.cloneDeep(item);
        if (_item.select_options.includes("&#34;")) {
          _item.select_options = JSON.parse(_item.select_options.replaceAll("&#34;", '"'))
        }
        return _item;
      });
      return reports;
    },

    contents () {
      return this.getContents();
    }
  },
  methods: {
    ...mapActions(["setReportDetail"]),

    getValue (form) {
      const id = form.id;

      const obj = this.reportDetail.find(val => {
        return val.item_id === id;
      });

      if (!obj) return;

      if (form.input_type === VESSEL_BEHAVIOR_REPORT_INPUT_TYPES.HIERARCHICAL_SELECT.key) {
        return {
          value: obj.value ? obj.value : null,
          parent_value: obj.parent_value ? obj.parent_value : null,
        };
      }

      return obj.value ? obj.value : null;
    },

    setContentsValue (payload) {
      this.contentsValue[payload.id] = payload;
    },

    getComponentName (inputType) {
      const inputTypes = Object.values(VESSEL_BEHAVIOR_REPORT_INPUT_TYPES);
      return inputTypes.find(item => item.key === inputType).component;
    },

    getContents () {
      return this.forms.map((item) => {

        let payload = {
          item_id: item.id,
          item_name: item.label,
          order: item.order,
          label: "",
          value: "",
          is_alert: false,
        }

        if (this.contentsValue[item.id]) {
          payload.value = this.contentsValue[item.id].value;
          payload.label = this.contentsValue[item.id].label;
          payload.is_alert = this.contentsValue[item.id].isAlert;

          if (this.contentsValue[item.id].parent_value) {
            payload.parent_value = this.contentsValue[item.id].parent_value;
          }

        }
        return payload;
      });
    },

    async postReportDetail () {

      const contents = this.getContents();
      const escapedContents = JSON.stringify(contents).replaceAll('"', '\"');

      const payload = {
        vesselId: this.$route.params.vesselId,
        reportId: this.$route.params.reportId,
        requestBody: {
          version: this.version + 1,
          contents: escapedContents
        }
      }

      await this.setReportDetail(payload);
    }
  },

}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/vessel-noon-report.scss";

#noon-report-list {
  --vs-primary: 3, 155, 229;
}
</style>
